export default __webpack_public_path__ + "static/media/ash.31b21ff6.png";